import types from 'redux/types';

const getBalance = () => ({
  type: types.REQUEST_API_BALANCE,
});

const clearBalance = () => ({
  type: types.REQUEST_CLEAR_BALANCE,
});

export default {
  getBalance,
  clearBalance,
};
